import type { EndpointMap } from '../common';
import type { ListNotificationsRequest } from './notification.request';
import type { ListNotificationsResponse } from './notification.response';

/** D3 회원 알림(D3 · 관리자). 알림은 메모 · 리포트 파일 · 리포트 데이터가 바뀔 때 서버가 만든다 */
export const notificationEndpoints = {
  listNotifications: {
    method: 'GET',
    path: '/notifications',
    req: {} as ListNotificationsRequest,
    res: {} as ListNotificationsResponse,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS'],
  },
  readNotification: {
    method: 'PUT',
    path: '/notifications/:id/read',
    res: undefined as void,
    errors: ['NOT_FOUND_NOTIFICATION'],
  },
  readAllNotifications: {
    method: 'PUT',
    path: '/notifications/read',
    res: undefined as void,
  },
} as const satisfies EndpointMap;
